import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from 'react-bootstrap/ListGroup';
import Select from 'react-select';
import Loader from '../../common/Loader';
import UserRow from './UserRow';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';
import { connect } from 'react-redux';
import { AppState } from '../../../store';

export interface IProps {
    userId: string;
}

export interface User {
    Code: string;
    Status: any;
    UserId: number;
    UserName: string;
    AreaDesc: string;
}

export interface User2 {
    UserId: string;
    DisplayName: string;
    AreaDesc: string;
}

const ManageAccessCodes: React.FC<IProps> = (props: IProps) => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState(null as any);
    const [addUser, setAddUser] = React.useState({ open: false, value: null } as {open: boolean, value: any});
    const [users, setUsers] = React.useState([] as Array<any>);
    const [adding, setAdding] = React.useState(false);
    const [error, setError] = React.useState("");
    const [used, setUsed] = React.useState([] as any);
    // const used: any = React.useRef();

    const handleDelete = (userId: number) => {
        let copy: Array<User> = [...data];
        let foundIndex: number = copy.findIndex((u: User) => u.UserId === userId);
        if(foundIndex >= 0){
            copy.splice(foundIndex, 1);
            setTimeout(() => {
                setData(copy);
            }, 2000)
        }
    }

    const toggleAddUser = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setAddUser({ ...addUser, open: !addUser.open });
    }

    const handleSelect = (selection: any) => { 
        setAddUser({ ...addUser, value: selection }); 
    }

    const handleSave = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setAdding(true);
        if(addUser.value !== null){
            //console.log(addUser);
            axios.get(process.env.REACT_APP_API_URL + `/api/user/setaccesscode/${addUser.value.value}`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log(res);
                const updated: any = res.data[0];
                if(updated){
                    //console.log("Updated: ", updated)
                    const foundIndex: number = data.findIndex((u: User) => u.UserId === addUser.value.value);
                    if(foundIndex === -1){
                        setData([...data, updated]);
                        setUsed([...used, updated.UserId]);
                    }else{
                        let copy: any = [...data];
                        copy.splice(foundIndex, 1, updated);
                        setData(copy);
                    }
                    setAddUser({ open: false, value: null });
                    setError("");
                }
            })
            .catch((err: any) => {
                //console.log(err);
                AxiosConfig.configValue("min");
                setError(`There was an error adding ${addUser.value.label || ""}`)
            })
            .finally(() => { setAdding(false); })
        }
    }

    const handleRefresh = (e: React.SyntheticEvent) => {
        e.preventDefault();
        getUsersAndCodes();
    }

    const getUsersAndCodes = () => {
        setLoading(true);
        const availableUsersCall: any = axios.get(process.env.REACT_APP_API_URL + "/api/user/accesscodeusers", AxiosConfig.configValue("min"));
        const accessCodesCall: any = axios.get(process.env.REACT_APP_API_URL + "/api/user/accesscodes/-1", AxiosConfig.configValue("min"));
        axios.all([accessCodesCall, availableUsersCall])
        .then((responses: any) => {
            //console.log("Responses: ", responses);
            const [accessCodesRes, availableUsersResponse] = responses;
            setData(accessCodesRes.data);
            // used.current = accessCodesRes.data.map((u: any) => u.UserId);
            setUsed(accessCodesRes.data.map((u: any) => u.UserId));
            setUsers(availableUsersResponse.data);
            setError("");
        })
        .catch((err: any) => {
            //console.log(err, err.response);
            AxiosConfig.handleError(err);
            setError("There was an error getting users. Please try again.");
        })
        .finally(() => {
            setLoading(false);
        })
    }

    React.useEffect(() => { getUsersAndCodes(); }, [])

    return (
        <div className="col-12 col-sm-9" style={{maxHeight: 500, minHeight: 400, overflowY: "scroll"}}>
            <div className="space-between w-100">
                <h3 style={{position: "sticky", top: 0, zIndex: 1}} className="text-underline w-100 py-1 bg-white d-flex align-items-center flex-row">
                    <i className="material-icons text-success h3 m-0">admin_panel_settings</i>
                    <span>Manage Access Codes</span>
                </h3>
                {
                    addUser.open
                    ?
                    <div style={{maxHeight: 45}} className="space-between w-60">
                        <Select
                            key={used}
                            name="user" 
                            options={users.filter((u: User2) => used?.indexOf(u.UserId) < 0).map((u: User2) => ({ label: `${u.DisplayName}, ${u.AreaDesc}`, value: u.UserId }))}
                            onChange={handleSelect}
                            value={addUser.value}
                            className="w-80"
                        />
                        { adding ? <Spinner size="sm" animation="border"/> : <button onClick={handleSave} className="action-text material-icons">save</button>}
                        <button onClick={toggleAddUser} className="action-text-danger material-icons">close</button>
                    </div>
                    :
                    <>
                    <button disabled={loading} onClick={toggleAddUser} className="action-text material-icons">add</button>
                    {loading ? <Spinner size="sm" animation="border" /> : <button onClick={handleRefresh} className="action-text material-icons">autorenew</button>}
                    </>
                }
            </div>
            {error !== "" && 
            <div className="alert alert-danger">
                {error}
            </div>
            }
            {
                loading
                ?
                <div className="d-flex justify-content-center" style={{height: 450}}><Loader title="Loading..." /></div>
                :
                <ListGroup className="w-100">
                    {data?.map((user: User) => <UserRow key={user.UserId} deleteCb={handleDelete} user={user} />)}
                </ListGroup>
            }
        </div>
    );
}

const mapStateToProps = (state: AppState) => ({ userId: state.user.userId });

export default connect(mapStateToProps)(ManageAccessCodes);